// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3G4Pllsrk9l83XUT0QEyK1","title":"_1LrpCQ3Q1bOcjwv-pskJVQ","subTitle":"_1ejhDbI2RfxWtZFMbyLS_N","fieldWrapper":"rm1fR97bO1k6V5S21TqM9","fieldTitle":"_2Bo3W7rcYdl7v7aG7LqleH","phoneNumber":"_1ALrHQQxKNLQ37XXKXt2_9","submit":"_3JWk3OwjGFj6khUV4N7D04","required":"zvHS-zyHmL8RmZHJN7SXI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EditUserStaff/EditUserStaff.scss
// module id = 1802
// module chunks = 0